export const JOBS_PER_GROUP = 50;       // Total jobs allowed per group
export const GROUPS_REFRESH_INTERVAL_MIN = 0.5;  // in-progress groups refresh interval in minutes
export const MDX_PAGE_REFRESH_INTERVAL_MIN = 5;  // MDX page refresh interval in minutes
export const GROUPS_PER_PAGE = 10;      // Total groups allowed per page for MDX table